/* ============================================================
   MAAREE Fit Finder — vanilla JS widget
   Mounts into any element: MaareeFitFinder.mount(el, opts)
   Requires sizing-data.js loaded first (window.MAAREE_SIZING).

   opts:
     urls       — { solidarity, battle, empower, uplift, seamless } PDP overrides
     products   — { solidarity: { title, url, image, available }, ... } live Shopify data
                  (supplied by maaree-sg-fit-finder.liquid via its JSON block)
   ============================================================ */
(function (global) {
  'use strict';

  // ============================================================
  // ▼▼▼ DATA CAPTURE CONFIG — the only thing you may need to edit ▼▼▼
  // ============================================================
  var CONFIG = {
    // 1) GOOGLE SHEET (anonymous logging).
    //    Paste your Google Apps Script Web App URL between the quotes
    //    (ends in /exec). Until you do, logging is simply skipped — no errors.
    SHEET_ENDPOINT: 'https://script.google.com/macros/s/AKfycbzojiLlM3NAOGd2-tAA-XuxFaB_PWIN4w_kChqd1mZE5ldySYCsTUgsEiiNPMWWmjbQBQ/exec',

    // 2) EMAIL CAPTURE via Klaviyo.
    //    false = off (anonymous Sheet logging only).
    //    true  = show the optional "email my results" stage.
    COLLECT_EMAIL: true,

    // If COLLECT_EMAIL is true and you want email REQUIRED before
    // results are shown (a hard gate), set this to true.
    EMAIL_REQUIRED: false,

    // Your Klaviyo public API key (site ID). Already set for MAAREE.
    KLAVIYO_PUBLIC_KEY: 'JS998s',

    // Klaviyo list opt-ins are subscribed to (marketing consent).
    // '[FLOW] Welcome — Fit Finder' — feeds the Welcome flow.
    KLAVIYO_LIST_ID: 'UqtGYz',

    // The Klaviyo metric these submissions show up under.
    KLAVIYO_METRIC: 'Completed Fit Finder',

    // 3) BOOST BREAST FORM SIZING (Breast Cancer Awareness Month).
    //    Off by default. sections/maaree-sg-fit-finder.liquid switches this
    //    on only while the campaign state is 'bcam', so it disappears on
    //    1 November on its own with nothing to undo.
    BOOST_ENABLED: false,
    BOOST_OPTIN_LABEL: 'Also size me for a Boost breast form',
    BOOST_OPTIN_SUB: 'For anyone wearing a breast form after surgery. Free this month with our partners Boost.',
    BOOST_EYEBROW: 'In partnership with Boost',
    BOOST_TITLE: 'Your Boost breast form size',
    BOOST_NOTE: 'A breast form is a personal fit, so treat this as a starting point. Book a free fitting with us this month and one of our fitters will size you for your bra and your form on the same call.',
    BOOST_CTA_LABEL: 'Buy from Boost',
    BOOST_CTA_URL: 'https://wewearboost.com/breast-forms/'
  };
  // Allow the theme/Liquid to override the above without editing this file.
  if (global.MAAREE_FIT_FINDER_CONFIG) {
    for (var _ck in global.MAAREE_FIT_FINDER_CONFIG) {
      if (Object.prototype.hasOwnProperty.call(global.MAAREE_FIT_FINDER_CONFIG, _ck)) {
        CONFIG[_ck] = global.MAAREE_FIT_FINDER_CONFIG[_ck];
      }
    }
  }
  // ============================================================
  // ▲▲▲ END CONFIG ▲▲▲
  // ============================================================

  // ---------- helpers ----------
  var SIZING = global.MAAREE_SIZING;
  var STORAGE_KEY = 'maaree_fit_v1';
  var STORAGE_TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'class') n.className = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
      }
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null || c === false) return;
        n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return n;
  }

  // ---------- one-off injected styles: location questions layout ----------
  // Two columns on desktop, stacked on mobile. Inside the side drawer the
  // shell is only 480px wide, so it stays stacked there too.
  function ensureGeoStyles() {
    try {
      if (document.getElementById('mff-geo-styles')) return;
      var st = document.createElement('style');
      st.id = 'mff-geo-styles';
      st.textContent =
        '.mff-geo{display:grid;grid-template-columns:1fr;gap:18px;}' +
        '@media (min-width:641px){' +
          '.mff-geo{grid-template-columns:1fr 1fr;gap:14px;align-items:start;}' +
          '.mff-drawer__body .mff-geo{grid-template-columns:1fr;gap:18px;}' +
        '}';
      document.head.appendChild(st);
    } catch (e) { /* styling only — never break the widget */ }
  }

  // ---------- one-off injected styles: email-step discount sticker ----------
  // A rotated black circular "sticker" tucked into the top-right corner of
  // the widget's OWN card, overlapping the "Almost there" / "Worried you'll
  // forget?" heading area. Deliberately kept fully inside the widget's box:
  // the theme wraps this widget in ".maaree-fit-finder-mount" (overflow-x:
  // hidden, so it can clip content to the card's rounded corners) on the
  // inline page embed, and the side-drawer panel sits flush against the
  // browser's right edge with no gap at all — so anything positioned
  // OUTSIDE the widget's box gets clipped or pushed off-screen in every
  // real context. Living inside the corner avoids that entirely and shows
  // up the same way on mobile and desktop, drawer or inline.
  function ensureStickerStyles() {
    try {
      if (document.getElementById('mff-sticker-styles')) return;
      var st = document.createElement('style');
      st.id = 'mff-sticker-styles';
      st.textContent =
        '.mff-sticker{position:absolute;top:10px;right:10px;width:86px;height:86px;' +
          'border-radius:50%;background:#000;color:#fff;display:flex;flex-direction:column;' +
          'align-items:center;justify-content:center;gap:1px;text-align:center;padding:8px;' +
          'transform:rotate(9deg);box-shadow:0 6px 16px rgba(0,0,0,0.2);z-index:2;}' +
        '.mff-sticker__get{font-size:8px;font-weight:700;letter-spacing:0.04em;' +
          'text-transform:uppercase;line-height:1;opacity:0.85;}' +
        '.mff-sticker__pct{font-size:17px;font-weight:800;line-height:1.05;}' +
        '.mff-sticker__off{font-size:7.5px;font-weight:700;letter-spacing:0.03em;' +
          'text-transform:uppercase;line-height:1.2;max-width:64px;}' +
        // Give the heading breathing room so its text wraps clear of the
        // badge instead of running underneath it.
        '.mff-email .mff-step__head{padding-right:96px;}' +
        '@media (max-width:360px){' +
          '.mff-sticker{width:68px;height:68px;top:6px;right:6px;padding:6px;}' +
          '.mff-sticker__pct{font-size:14px;}' +
          '.mff-sticker__off{font-size:7px;max-width:52px;}' +
          '.mff-email .mff-step__head{padding-right:78px;}' +
        '}';
      document.head.appendChild(st);
    } catch (e) { /* styling only — never break the widget */ }
  }

  // ---------- data capture: Google Sheet (anonymous) ----------
  // Fire-and-forget POST. no-cors so no preflight and no console noise;
  // we don't need to read the response, the row still lands in the Sheet.
  function sendToSheet(record) {
    if (!CONFIG.SHEET_ENDPOINT) return;
    try {
      fetch(CONFIG.SHEET_ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(record),
        keepalive: true
      }).catch(function () {});
    } catch (e) { /* never let logging break the widget */ }
  }

  // Fire-and-forget UPDATE to the Sheet: patches an existing row (matched by
  // submission_id) so an email opt-in fills the opt-in / name / email columns
  // on the SAME row rather than adding a new one.
  function sendSheetUpdate(payload) {
    if (!CONFIG.SHEET_ENDPOINT || !payload || !payload.submission_id) return;
    try {
      fetch(CONFIG.SHEET_ENDPOINT, {
        method: 'POST', mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(Object.assign({ action: 'update' }, payload)),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }
  // A random id per completed submission so a later opt-in can find its row.
  function newSubmissionId() {
    try {
      return (global.crypto && global.crypto.randomUUID)
        ? global.crypto.randomUUID()
        : 's-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    } catch (e) { return 's-' + Date.now(); }
  }

  // ---------- data capture: Klaviyo (email opt-in) ----------
  // Uses Klaviyo's public Client APIs (no secret key needed).
  // Fires the metric event (with all answers as properties) and,
  // if a list id is set, subscribes the email with marketing consent.
  function klaviyoCapture(email, record, firstName) {
    if (!CONFIG.KLAVIYO_PUBLIC_KEY) return;
    var key = encodeURIComponent(CONFIG.KLAVIYO_PUBLIC_KEY);
    var headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };

    // Key answers as PROFILE properties (not just event properties) so they
    // are easy to segment and personalise on in Klaviyo.
    var profileAttrs = { email: email };
    if (firstName) profileAttrs.first_name = firstName;
    if (record) {
      profileAttrs.properties = {
        based_in: record.based_in || '',
        sizing_chart_nationality: record.sizing_chart_nationality || '',
        fit_uk_size: record.uk_size || '',
        fit_recommended_style: record.recommended_style || '',
        fit_recommended_name: record.recommended_name || '',
        fit_activity: record.activity || '',
        fit_issues: record.issues || '',
        fit_boost_optin: record.boost_opt_in || '',
        fit_boost_size: record.boost_size || '',
        fit_completed_at: record.submitted_at || ''
      };
    }

    try {
      // 1) Track the submission as an event (creates/updates the profile by email)
      fetch('https://a.klaviyo.com/client/events/?company_id=' + key, {
        method: 'POST', headers: headers, keepalive: true,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: record || {},
              metric: { data: { type: 'metric', attributes: { name: CONFIG.KLAVIYO_METRIC } } },
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            }
          }
        })
      }).catch(function () {});

      // 2) Subscribe to a list (marketing consent) — only if a list id is set
      if (CONFIG.KLAVIYO_LIST_ID) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + key, {
          method: 'POST', headers: headers, keepalive: true,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Fit Finder',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: Object.assign(
                      { email: email,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
                      firstName ? { first_name: firstName } : {}
                    )
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: CONFIG.KLAVIYO_LIST_ID } } }
            }
          })
        }).catch(function () {});
      }
    } catch (e) { /* never let capture break the widget */ }
  }

  // Build a flat, Sheet-friendly record of one completed submission.
  function buildSubmission(self, result) {
    var s = self.state;
    // The winning bra's live product data (same object the results page renders
    // its hero image from) so the email can show the exact same image.
    var bestProd = (self.products && self.products[result.bestStyle]) || {};
    function styleSize(k) {
      var r = result.recs[k];
      if (!r) return '';
      if (r.unavailable) return 'n/a';
      return localiseDisplay(r, result.region) || r.size || '';
    }
    return {
      submitted_at: new Date().toISOString(),
      sizing_chart_nationality: result.region || s.region || '',
      based_in: s.basedIn || '',
      units: s.units || '',
      underband: s.underband || '',
      bust: s.bust || '',
      knows_current_size: s.hasCurrentSize === 'yes' ? 'yes' : 'no',
      current_brand: s.currentBrand || '',
      current_band: s.currentBand || '',
      current_cup: s.currentCup || '',
      issues: (s.issues || []).join(' | '),
      last_fitter: s.fitterSource || '',
      body_change: s.bodyChange || '',
      activity: s.activity || '',
      boost_opt_in: s.boost ? 'yes' : 'no',
      boost_size: (function () {
        if (!s.boost || !result.boost || !result.boost.options.length) return '';
        return result.boost.options.map(function (o) { return o.size + ' ' + o.shape; }).join(' or ');
      })(),
      uk_size: result.ukSize || '',
      final_band: result.finalBand || '',
      final_cup: result.finalCup || '',
      recommended_style: result.bestStyle || '',
      recommended_name: (STYLE_META[result.bestStyle] && STYLE_META[result.bestStyle].name) || bestProd.title || '',
      recommended_url: bestProd.url || (STYLE_META[result.bestStyle] && STYLE_META[result.bestStyle].url) || '',
      recommended_image: bestProd.image || '',
      size_solidarity: styleSize('solidarity'),
      size_battle: styleSize('battle'),
      size_empower: styleSize('empower'),
      size_uplift: styleSize('uplift'),
      size_seamless: styleSize('seamless'),
      best_reason: result.bestReason || '',
      fitting_notes: (result.notes || []).join(' | '),
      style_notes: (function () {
        var out = [];
        ['solidarity','battle','empower','uplift','seamless'].forEach(function (k) {
          var r = result.recs && result.recs[k];
          if (!r) return;
          var bits = [];
          if (r.note) bits.push(r.note);
          if (r.warn) bits.push(r.warn);
          if (bits.length) out.push(k + ': ' + bits.join(' '));
        });
        return out.join(' | ');
      })(),
      flags: (function () {
        var f = [];
        if (result.unitWarning) f.push(result.unitWarning);
        if (result.flag && result.flagReasons && result.flagReasons.length) f.push('re-measure: ' + result.flagReasons.join(', '));
        if (result.deadEnd) f.push('dead-end: no size matched');
        return f.join(' | ');
      })(),
      page_path: (global.location && global.location.pathname) || '',
      source: 'fit-finder',
      visitor_id: getVisitorId(),
      visit_number: nextVisitNumber(),
      submission_id: newSubmissionId(),
      email_optin: 'no',
      first_name: '',
      name: '',
      email: ''
    };
  }

  // ---------- localStorage persistence ----------
  function loadStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj.completedAt || (Date.now() - obj.completedAt) > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return obj;
    } catch (e) { return null; }
  }
  function saveStored(obj) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); }
    catch (e) {}
  }
  function clearStored() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // ---------- anonymous visitor id (repeat-use tracking, no personal data) ----------
  // A random per-device id, created once and reused. Lets you group repeat
  // submissions from the same person when analysing — without storing any IP
  // or personal data. Per-device only (incognito / a different browser looks new).
  var VID_KEY = 'maaree_vid';
  var VISITS_KEY = 'maaree_visits';
  function getVisitorId() {
    try {
      var id = localStorage.getItem(VID_KEY);
      if (!id) {
        id = (global.crypto && global.crypto.randomUUID)
          ? global.crypto.randomUUID()
          : 'v-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(VID_KEY, id);
      }
      return id;
    } catch (e) { return ''; }
  }
  function nextVisitNumber() {
    try {
      var n = (parseInt(localStorage.getItem(VISITS_KEY), 10) || 0) + 1;
      localStorage.setItem(VISITS_KEY, String(n));
      return n;
    } catch (e) { return ''; }
  }

  // ---------- catalog ----------
  var STYLE_META = {
    uplift:     { name: 'Uplift',              impact: 'Medium',         tagline: 'Medium-impact all-rounder',     url: '/products/uplift' },
    empower:    { name: 'Empower',             impact: 'Medium-to-high', tagline: 'Strength-training favourite',   url: '/products/empower' },
    seamless:   { name: 'Supportive Seamless', impact: 'Light',          tagline: 'Yoga, Pilates, low-impact',     url: '/products/seamless' },
    solidarity: { name: 'Solidarity',          impact: 'High',           tagline: 'Highest support, up to HH cup', url: '/products/solidarity' },
    battle:     { name: 'Battle',              impact: 'High',           tagline: 'High-impact, locked-in',        url: '/products/battle' }
  };

  var ISSUE_OPTIONS = [
    { id: 'none',              label: "No issues, I'm just checking my size" },
    { id: 'chafing',           label: 'Chafing under the band' },
    { id: 'riding-up',         label: 'Underband rides up at the back' },
    { id: 'straps-digging',    label: 'Straps dig into my shoulders' },
    { id: 'tightening-straps', label: 'Always tightening my straps' },
    { id: 'band-too-tight',    label: 'Underband feels too tight' },
    { id: 'spillage',          label: 'Spillage / cups overflow' },
    { id: 'gaping',            label: 'Cups gape or wrinkle' },
    { id: 'bouncing',          label: 'My breasts bounce when I move' }
  ];

  var FITTER_OPTS = [
    { id: 'none',       label: 'No, never been fitted' },
    { id: 'ms',         label: 'M&S' },
    { id: 'boobydoo',   label: 'Boobydoo' },
    { id: 'bravissimo', label: 'Bravissimo' },
    { id: 'rigby',      label: 'Rigby & Peller' },
    { id: 'other',      label: 'Other / Independent' }
  ];

  var ACTIVITY_OPTS = [
    { id: 'low',    label: 'Low impact',    sub: 'Yoga, walking, day-to-day' },
    { id: 'medium', label: 'Medium impact', sub: 'Strength, dance, classes' },
    { id: 'high',   label: 'High impact',   sub: 'Running, HIIT, contact' }
  ];

  var REGION_OPTS = [
    { id: 'UK', label: 'United Kingdom' }, { id: 'US', label: 'United States' },
    { id: 'CA', label: 'Canada' }, { id: 'AU', label: 'Australia' },
    { id: 'NZ', label: 'New Zealand' }, { id: 'FR', label: 'France' },
    { id: 'IT', label: 'Italy' }, { id: 'EU', label: 'Rest of Europe' }
  ];

  // "Where are you based?" — actual location/market, separate from sizing.
  var BASED_OPTS = [
    { id: 'UK', label: 'United Kingdom' }, { id: 'US', label: 'United States' },
    { id: 'CA', label: 'Canada' }, { id: 'AU', label: 'Australia' },
    { id: 'NZ', label: 'New Zealand' }, { id: 'EU', label: 'Europe (EU)' },
    { id: 'OTHER', label: 'Somewhere else' }
  ];

  var KNOWN_BRANDS = ['M&S','Bravissimo','Shock Absorber','Nike','Lululemon','Sweaty Betty','Gymshark','Other'];
  var BANDS = [28,30,32,34,36,38,40];
  var CUPS  = ['A','B','C','D','DD','E','F','FF','G','GG','H','HH'];

  // ---------- localised display helper ----------
  function localiseDisplay(rec, region) {
    if (!rec || !rec.size) return '—';
    // Letter-sized styles (Uplift/Empower/Seamless) are universal — no country label.
    if (!rec.band || !rec.cup) return rec.size;
    // Band+cup styles (Solidarity/Battle): cup letters differ by country, so always
    // show the UK size, and add the local conversion when the shopper isn't in the UK.
    var uk = '' + rec.band + rec.cup;
    if (!region || region === 'UK') return uk + ' (UK)';
    var loc = SIZING.localiseSize(rec.band, rec.cup, region);
    return uk + ' (UK) / ' + loc.label + ' (' + region + ')';
  }

  // ============================================================
  // Component
  // ============================================================
  function FitFinder(root, opts) {
    opts = opts || {};
    this.root = root;
    this.opts = opts;
    this.onComplete = opts.onComplete || function () {};
    this.currentProductKey = opts.currentProductKey || null;
    this.urls = opts.urls || {};
    this.products = opts.products || {};
    this.emailHandled = false;   // becomes true once the email stage is submitted or skipped
    this.lastSubmission = null;  // flat record of the most recent completion

    ensureGeoStyles();
    ensureStickerStyles();

    this.state = {
      step: 0, region: '', basedIn: '', units: 'in',
      underband: '', bust: '',
      hasCurrentSize: 'yes', currentBrand: '', currentBand: '', currentCup: '',
      noIdeaOfSize: false,
      issues: [], fitterSource: '', fittedRecently: null, bodyChange: null,
      activity: '', fitting: 'standard', boost: false
    };

    // Restore in-progress quiz if user previously started one
    var stored = loadStored();
    if (stored && stored.inProgress) {
      Object.assign(this.state, stored.inProgress);
    }

    this.render();
  }

  FitFinder.prototype.setStep = function (n) {
    this.state.step = Math.max(0, Math.min(6, n));
    this.render();
    if (this.root) this.root.scrollTop = 0;
  };

  FitFinder.prototype.setState = function (patch) {
    Object.assign(this.state, patch);
    this.render();
  };

  FitFinder.prototype.computeResult = function () {
    var s = this.state;
    if (!s.underband || !s.bust) return null;
    var u = parseFloat(s.underband), b = parseFloat(s.bust);
    if (isNaN(u) || isNaN(b) || u <= 0 || b <= 0) return null;
    return SIZING.getRecommendations({
      underband: u, bust: b, units: s.units, region: s.region,
      current: s.hasCurrentSize === 'yes' ? { brand: s.currentBrand, band: s.currentBand, cup: s.currentCup } : null,
      issues: s.issues, fitting: s.fitting, activity: s.activity,
      fitterSource: s.fitterSource, bodyChange: s.bodyChange
    });
  };

  FitFinder.prototype.restart = function () {
    this.emailHandled = false;
    this.lastSubmission = null;
    this.state = {
      step: 0, region: '', basedIn: '', units: 'in',
      underband: '', bust: '',
      hasCurrentSize: 'yes', currentBrand: '', currentBand: '', currentCup: '',
      noIdeaOfSize: false,
      issues: [], fitterSource: '', fittedRecently: null, bodyChange: null,
      activity: '', fitting: 'standard', boost: false
    };
    this.render();
  };

  FitFinder.prototype.persistResult = function (result) {
    if (!result) return;
    var recs = {};
    Object.keys(result.recs).forEach(function (k) {
      var r = result.recs[k];
      recs[k] = r.unavailable ? { unavailable: true } : { size: r.size, band: r.band || null, cup: r.cup || null };
    });
    var payload = {
      ukSize: result.ukSize,
      band: result.finalBand,
      cup: result.finalCup,
      region: result.region,
      bestStyle: result.bestStyle,
      recommendations: recs,
      measurements: { underband: this.state.underband, bust: this.state.bust, units: this.state.units },
      completedAt: Date.now()
    };
    saveStored(payload);
    this.onComplete(payload);
    // Fire global event so PDP listeners can re-render their button
    try {
      window.dispatchEvent(new CustomEvent('maaree:fit-result', { detail: payload }));
    } catch (e) {}

    // NEW: anonymous data capture to the Google Sheet (runs for everyone)
    try {
      this.lastSubmission = buildSubmission(this, result);
      sendToSheet(this.lastSubmission);
    } catch (e) {}
  };

  // ============================================================
  // Rendering
  // ============================================================
  // Which raw steps are actually shown, given whether she knows her size.
  FitFinder.prototype.stepFlow = function () {
    return (this.state.hasCurrentSize === 'yes') ? [1, 2, 3, 4, 5] : [1, 4, 5];
  };
  FitFinder.prototype.stepMeta = function () {
    var flow = this.stepFlow();
    var idx = flow.indexOf(this.state.step);
    return { total: flow.length, idx: idx, num: idx + 1 };
  };
  FitFinder.prototype.stepEyebrow = function () {
    var m = this.stepMeta();
    return m.idx >= 0 ? ('Step ' + m.num + ' of ' + m.total) : '';
  };

  FitFinder.prototype.render = function () {
    var s = this.state;
    this.root.innerHTML = '';
    var shell = el('div', { class: 'mff-shell' });
    var meta = this.stepMeta();
    if (meta.idx >= 0) {
      shell.appendChild(this.renderProgress(meta.total, meta.idx));
    }
    var stage = el('div', { class: 'mff-stage' });
    // Order: intro -> start (country + sizing system) -> details (current bra,
    // or "no idea" skip) -> [issues if she knows her size] -> measure -> activity -> result
    if (s.step === 0) stage.appendChild(this.renderIntro());
    else if (s.step === 1) stage.appendChild(this.renderStart());
    else if (s.step === 2) stage.appendChild(this.renderDetails());
    else if (s.step === 3) stage.appendChild(this.renderIssues());
    else if (s.step === 4) stage.appendChild(this.renderMeasure());
    else if (s.step === 5) stage.appendChild(this.renderActivity());
    else if (s.step === 6) {
      // Optional email stage sits in front of the result when enabled.
      // Skip it entirely when the measurements are going to dead-end
      // anyway — nothing to email, go straight to the recheck screen.
      var r6 = this.computeResult();
      var isDeadEnd6 = !!(r6 && r6.deadEnd);
      if (CONFIG.COLLECT_EMAIL && !this.emailHandled && !isDeadEnd6) stage.appendChild(this.renderEmail());
      else stage.appendChild(this.renderResult());
    }
    shell.appendChild(stage);
    shell.appendChild(this.renderFoot());
    this.root.appendChild(shell);
  };

  FitFinder.prototype.renderProgress = function (total, current) {
    var wrap = el('div', { class: 'mff-progress' });
    for (var i = 0; i < total; i++) {
      wrap.appendChild(el('span', { class: 'mff-progress__dot' + (i <= current ? ' is-active' : '') }));
    }
    return wrap;
  };

  FitFinder.prototype.renderFoot = function () {
    return el('footer', { class: 'mff-foot' }, [
      el('span', null, 'MAAREE Bra Fit Finder'),
      el('span', { class: 'mff-foot__sep' }, '·'),
      el('span', null, 'Sized across all 5 styles')
    ]);
  };

  // --- helper builders ---
  FitFinder.prototype.head = function (eyebrow, title, sub) {
    var head = el('div', { class: 'mff-step__head' });
    if (eyebrow) head.appendChild(el('span', { class: 'mff-eyebrow' }, eyebrow));
    head.appendChild(el('h2', { class: 'mff-step__title' }, title));
    if (sub) head.appendChild(el('p', { class: 'mff-step__sub' }, sub));
    return head;
  };

  FitFinder.prototype.tile = function (label, sub, selected, disabled, onClick) {
    var btn = el('button', {
      type: 'button',
      class: 'mff-tile' + (selected ? ' is-selected' : '') + (disabled ? ' is-disabled' : ''),
      onclick: function () { if (!disabled) onClick(); }
    });
    btn.appendChild(el('span', { class: 'mff-tile__label' }, label));
    if (sub) btn.appendChild(el('span', { class: 'mff-tile__sub' }, sub));
    btn.appendChild(el('span', { class: 'mff-tile__check', html:
      '<svg viewBox="0 0 16 16" width="14" height="14"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    }));
    return btn;
  };

  FitFinder.prototype.actions = function (backFn, nextLabel, nextDisabled, nextFn) {
    var wrap = el('div', { class: 'mff-actions' });
    if (backFn) wrap.appendChild(el('button', { type: 'button', class: 'mff-btn mff-btn--ghost', onclick: backFn }, 'Back'));
    var nextAttrs = { type: 'button', class: 'mff-btn mff-btn--primary mff-btn--lg', onclick: nextFn };
    if (nextDisabled) nextAttrs.disabled = 'disabled';
    wrap.appendChild(el('button', nextAttrs, nextLabel));
    return wrap;
  };

  // --- step 0: intro ---
  FitFinder.prototype.renderIntro = function () {
    var self = this;
    var step = el('div', { class: 'mff-step' });
    step.appendChild(this.head('MAAREE Bra Fit Finder', 'Find your perfect MAAREE size',
      'A few quick questions and two measurements, and we will size you across all five MAAREE styles. Takes about a minute, and nothing is shared with anyone.'));

    var ul = el('ul', { class: 'mff-intro-list' });
    [
      'Tell us what you wear now',
      'Flag anything that bugs you about it',
      'Measure your underband and bust',
      'Get your size in every MAAREE style'
    ].forEach(function (txt, i) {
      ul.appendChild(el('li', null, [
        el('span', { class: 'mff-intro-list__num' }, String(i + 1)),
        el('span', null, txt)
      ]));
    });
    step.appendChild(ul);

    // What you'll need
    var need = el('div', { class: 'mff-intro-need' });
    need.appendChild(el('h3', { class: 'mff-subhead' }, "Before you start, grab:"));
    var needList = el('ul', { class: 'mff-intro-need__list' });
    [
      'A soft tape measure (any fabric tape works)',
      'Your current bra size, if you know it (optional)',
      'A non-padded, non-sports bra to measure in'
    ].forEach(function (txt) { needList.appendChild(el('li', null, txt)); });
    need.appendChild(needList);
    step.appendChild(need);

    // Boost breast form opt-in. Campaign only: CONFIG.BOOST_ENABLED is set
    // from Liquid and is false outside the campaign window, so this whole
    // block simply is not built the rest of the year.
    if (CONFIG.BOOST_ENABLED) {
      var boostRow = el('label', { class: 'mff-boost-optin' });
      var boostBox = el('input', {
        type: 'checkbox',
        class: 'mff-boost-optin__box',
        onchange: function (e) { self.state.boost = !!e.target.checked; }
      });
      boostBox.checked = !!self.state.boost;
      boostRow.appendChild(boostBox);
      boostRow.appendChild(el('span', { class: 'mff-boost-optin__text' }, [
        el('span', { class: 'mff-boost-optin__label' }, CONFIG.BOOST_OPTIN_LABEL),
        el('span', { class: 'mff-boost-optin__sub' }, CONFIG.BOOST_OPTIN_SUB)
      ]));
      step.appendChild(boostRow);
    }

    step.appendChild(el('button', {
      type: 'button', class: 'mff-btn mff-btn--primary mff-btn--lg mff-btn--block',
      onclick: function () { self.setStep(1); }
    }, 'Start Bra Fit Finder →'));
    step.appendChild(el('p', { class: 'mff-fineprint' }, 'No obligation, and you can come back to your answers later on this device.'));
    return step;
  };

  // --- step 1: measure ---
  FitFinder.prototype.renderMeasure = function () {
    var self = this, s = this.state;
    var u = parseFloat(s.underband), b = parseFloat(s.bust);
    var bothFilled = u > 0 && b > 0;
    var swapped = bothFilled && u > b;
    var valid = bothFilled && !swapped;

    var step = el('div', { class: 'mff-step' });
    step.appendChild(this.head(this.stepEyebrow(), 'Measure up',
      'Wear your best-fitting non-padded, non-sports bra so the tape sits where the band naturally would.'));

    // units
    var units = el('div', { class: 'mff-units' });
    ['in','cm'].forEach(function (id) {
      units.appendChild(el('button', {
        type: 'button',
        class: 'mff-units__opt' + (s.units === id ? ' is-active' : ''),
        onclick: function () { self.setState({ units: id }); }
      }, id === 'in' ? 'Inches' : 'Centimetres'));
    });
    step.appendChild(units);

    // measurements
    var grid = el('div', { class: 'mff-measure-grid', style: 'display:grid;grid-template-columns:repeat(2, minmax(0, 1fr));gap:16px;align-items:start;' });
    [
      { key: 'underband', label: 'Underband', hint: 'Snug, just under your bust where the band sits.' },
      { key: 'bust',      label: 'Bust',      hint: 'Loose, across the fullest part of your chest.' }
    ].forEach(function (f) {
      var input = el('input', {
        type: 'number', inputmode: 'decimal', step: '0.5', placeholder: '—',
        class: 'mff-input', value: s[f.key],
        // Prevent trackpad / mouse-wheel scroll from changing the value when the
        // input is focused. We blur on wheel so the page scrolls normally instead.
        onwheel: function (e) {
          if (document.activeElement === e.target) {
            e.preventDefault();
            e.target.blur();
          }
        },
        oninput: function (e) {
          // Update silently — full re-render would lose focus
          self.state[f.key] = e.target.value;
          // Light validity recompute for the next button
          var u2 = parseFloat(self.state.underband), b2 = parseFloat(self.state.bust);
          var ok = u2 > 0 && b2 > 0 && !(u2 > b2);
          var nextBtn = self.root.querySelector('.mff-actions .mff-btn--primary');
          if (nextBtn) ok ? nextBtn.removeAttribute('disabled') : nextBtn.setAttribute('disabled','disabled');
          var warn = self.root.querySelector('.mff-warn');
          var swappedNow = u2 > 0 && b2 > 0 && u2 > b2;
          if (swappedNow && !warn) {
            var w = el('div', { class: 'mff-warn' });
            w.innerHTML = '<strong>Double-check those numbers.</strong> Your bust measurement should be larger than your underband.';
            grid.parentNode.insertBefore(w, grid.nextSibling);
          } else if (!swappedNow && warn) {
            warn.parentNode.removeChild(warn);
          }
        }
      });
      var wrap = el('span', { class: 'mff-input-wrap' }, [input, el('span', { class: 'mff-input__unit' }, s.units)]);
      grid.appendChild(el('label', { class: 'mff-field' }, [
        el('span', { class: 'mff-field__label' }, f.label),
        wrap,
        el('span', { class: 'mff-field__hint' }, f.hint)
      ]));
    });
    step.appendChild(grid);

    if (swapped) {
      var w = el('div', { class: 'mff-warn' });
      w.innerHTML = '<strong>Double-check those numbers.</strong> Your bust measurement should be larger than your underband.';
      step.appendChild(w);
    }

    // help
    var help = el('details', { class: 'mff-help' });
    help.appendChild(el('summary', { class: 'mff-help__summary', style: 'display:flex;align-items:center;justify-content:space-between;gap:8px;list-style:none;cursor:pointer;' }, [
      el('span', null, 'How do I measure?'),
      el('span', { class: 'mff-help__chev', 'aria-hidden': 'true', html: '<svg viewBox="0 0 16 16" width="14" height="14"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' })
    ]));
    var ol = el('ol');
    [
      '<strong>Wear the right bra.</strong> Put on a normal, non-padded bra (no sports bras and no padding) so the tape sits where your band naturally would.',
      '<strong>Use a soft tape measure.</strong> If you only have a stiff one, wrap a piece of string around instead and hold it against a ruler afterwards.',
      '<strong>Stand tall.</strong> Stand up straight in front of a mirror with your arms relaxed by your sides. Lift an arm only to pass the tape around, then lower it before you read the number.',
      '<strong>Measure your underband.</strong> Wrap the tape around your ribcage, directly under your bust where the band sits. Keep it firm and level all the way round, snug but not so tight you cannot breathe. Breathe out, then read the number.',
      '<strong>Measure your bust.</strong> Wrap the tape loosely around the fullest part of your chest, usually across your nipple line. Keep it level across your back and let it rest. Do not pull it tight or it will read too small.',
      '<strong>Keep your units the same.</strong> Measure both in inches or both in centimetres, then pop the two numbers into the boxes above.',
      '<strong>Still unsure?</strong> If you land between sizes or a number looks off, measure once more, or book a free virtual fitting and we will do it together.'
    ].forEach(function (t) { var li = el('li'); li.innerHTML = t; ol.appendChild(li); });
    help.appendChild(ol);
    step.appendChild(help);

    step.appendChild(this.actions(
      function () { self.setStep(self.state.hasCurrentSize === 'yes' ? 3 : 2); },
      'Next →', !valid,
      function () {
        // Read live state, not the closure — input changes are silent.
        var u2 = parseFloat(self.state.underband), b2 = parseFloat(self.state.bust);
        if (u2 > 0 && b2 > 0 && !(u2 > b2)) self.setStep(5);
      }
    ));
    return step;
  };

  // --- step 1: where she shops / sizing system ---
  FitFinder.prototype.renderStart = function () {
    var self = this, s = this.state;
    var step = el('div', { class: 'mff-step' });
    step.appendChild(this.head(this.stepEyebrow(), 'What are you wearing now?',
      "Tell us where you shop. Next we'll ask for your current size, if you know it, so we can double-check our pick against it."));

    // Country / size-system selector — drives the current-size options on the next
    // step AND how we show results, so it sits first. We size in UK underneath and
    // show the shopper's chosen system on top.
    // Where she is based — her actual market. Sits first, and is deliberately
    // separate from the sizing question: plenty of US/EU/AU customers buy
    // their bras in UK sizing.
    var baseSel = el('select', { class: 'mff-select',
      onchange: function (e) { self.setState({ basedIn: e.target.value }); }
    });
    baseSel.appendChild(el('option', { value: '' }, 'Select a country…'));
    BASED_OPTS.forEach(function (r) {
      var o = el('option', { value: r.id }, r.label);
      if (r.id === s.basedIn) o.selected = true;
      baseSel.appendChild(o);
    });
    var baseField = el('label', { class: 'mff-field' }, [
      el('span', { class: 'mff-field__label' }, 'Where are you based?'),
      baseSel,
      el('span', { class: 'mff-field__hint' }, 'So we can point you to the right products and delivery info.')
    ]);

    // Sizing-chart nationality — her bra-size "currency": the chart she knows
    // her size in, not necessarily where she lives. No default on purpose.
    var regSel = el('select', { class: 'mff-select',
      onchange: function (e) { self.setState({ region: e.target.value }); }
    });
    regSel.appendChild(el('option', { value: '' }, 'Select a sizing system…'));
    REGION_OPTS.forEach(function (r) {
      var o = el('option', { value: r.id }, r.label);
      if (r.id === s.region) o.selected = true;
      regSel.appendChild(o);
    });
    var regField = el('label', { class: 'mff-field' }, [
      el('span', { class: 'mff-field__label' }, "Which country's sizing do you use?"),
      regSel,
      el('span', { class: 'mff-field__hint' }, "Not necessarily where you live — pick the sizing you know your bra size in.")
    ]);

    // Side by side on desktop, stacked on mobile (.mff-geo in the stylesheet)
    step.appendChild(el('div', { class: 'mff-geo' }, [baseField, regField]));

    step.appendChild(this.actions(
      function () { self.setStep(0); },
      'Next →', (!s.basedIn || !s.region),
      function () {
        var s2 = self.state;
        if (!s2.basedIn || !s2.region) return;
        // Everyone now goes to the current-size step; the "I really have no
        // idea" checkbox on that step is the only skip path, not this one.
        self.state.hasCurrentSize = 'yes';
        self.setStep(2);
      }
    ));
    return step;
  };

  // --- step 2: current bra details. Always shown now — the "I really have
  // no idea of my size" tile at the bottom is the only skip path (sets
  // hasCurrentSize back to 'no' and jumps straight to measurements). ---
  FitFinder.prototype.renderDetails = function () {
    var self = this, s = this.state;
    var canContinue = (s.currentBrand && s.currentBand && s.currentCup) || s.noIdeaOfSize;
    var step = el('div', { class: 'mff-step' });
    step.appendChild(this.head(this.stepEyebrow(), 'Your current bra',
      'Your size and when you were last fitted, so we can sense-check our recommendation against it.'));

      var cur = el('div', { class: 'mff-current' });
      var brandSel = el('select', { class: 'mff-select',
        onchange: function (e) { self.setState({ currentBrand: e.target.value }); }
      });
      brandSel.appendChild(el('option', { value: '' }, 'Select a brand…'));
      KNOWN_BRANDS.forEach(function (br) {
        var o = el('option', { value: br }, br);
        if (br === s.currentBrand) o.selected = true;
        brandSel.appendChild(o);
      });
      cur.appendChild(el('label', { class: 'mff-field' }, [
        el('span', { class: 'mff-field__label' }, 'Brand'), brandSel
      ]));
      var bc = el('div', { class: 'mff-bandcup' });
      var bandSel = el('select', { class: 'mff-select',
        onchange: function (e) { self.setState({ currentBand: e.target.value }); }
      });
      bandSel.appendChild(el('option', { value: '' }, '—'));
      BANDS.forEach(function (n) {
        // Label in the shopper's system, but keep the UK value so the engine is unchanged.
        var bandLabel = SIZING.localiseSize(n, 'D', s.region).band;
        var o = el('option', { value: n }, String(bandLabel));
        if (String(n) === String(s.currentBand)) o.selected = true;
        bandSel.appendChild(o);
      });
      var cupSel = el('select', { class: 'mff-select',
        onchange: function (e) { self.setState({ currentCup: e.target.value }); }
      });
      cupSel.appendChild(el('option', { value: '' }, '—'));
      CUPS.forEach(function (c) {
        // Label in the shopper's system, but keep the UK cup value for the engine.
        var cupLabel = SIZING.localiseSize(32, c, s.region).cup;
        var o = el('option', { value: c }, String(cupLabel));
        if (c === s.currentCup) o.selected = true;
        cupSel.appendChild(o);
      });
      bc.appendChild(el('label', { class: 'mff-field' }, [el('span', { class: 'mff-field__label' }, 'Band'), bandSel]));
      bc.appendChild(el('label', { class: 'mff-field' }, [el('span', { class: 'mff-field__label' }, 'Cup'),  cupSel]));
      cur.appendChild(bc);
      step.appendChild(cur);

      // Recent-fitting gate: only a fitting in the last 12 months informs sizing.
      var fitWrap = el('div', { class: 'mff-fitting' });
      fitWrap.appendChild(el('h3', { class: 'mff-subhead' }, 'Have you been fitted in the last 12 months?'));
      fitWrap.appendChild(el('p', { class: 'mff-subhead__sub' }, 'A recent fitting helps us calibrate. Older than that and we lead with your measurements instead.'));
      var fitSeg = el('div', { class: 'mff-segmented mff-segmented--two' });
      [['yes', 'Yes'], ['no', "No / not in the last 12 months"]].forEach(function (pair) {
        fitSeg.appendChild(el('button', {
          type: 'button',
          class: 'mff-segmented__opt' + (s.fittedRecently === pair[0] ? ' is-active' : ''),
          onclick: function () {
            if (pair[0] === 'no') self.setState({ fittedRecently: 'no', fitterSource: '' });
            else self.setState({ fittedRecently: 'yes' });
          }
        }, pair[1]));
      });
      fitWrap.appendChild(fitSeg);
      if (s.fittedRecently === 'yes') {
        var fitSel = el('select', { class: 'mff-select',
          onchange: function (e) { self.setState({ fitterSource: e.target.value }); }
        });
        fitSel.appendChild(el('option', { value: '' }, 'Where were you fitted?'));
        FITTER_OPTS.filter(function (o) { return o.id !== 'none'; }).forEach(function (o) {
          var opt = el('option', { value: o.id }, o.label);
          if (o.id === s.fitterSource) opt.selected = true;
          fitSel.appendChild(opt);
        });
        fitWrap.appendChild(el('label', { class: 'mff-field', style: 'margin-top:12px;' }, fitSel));
      }
      step.appendChild(fitWrap);

      // Dim (not remove) the fields above once she's said she has no idea —
      // keeps the page honest about what's actually being used.
      if (s.noIdeaOfSize) {
        cur.style.opacity = '0.45';
        cur.style.pointerEvents = 'none';
        fitWrap.style.opacity = '0.45';
        fitWrap.style.pointerEvents = 'none';
      }

      // Deliberate friction: no easy "skip" tile up front any more. This is
      // the one honest escape hatch, placed after she's already seen the
      // brand/band/cup fields, for shoppers who truly don't know their size.
      // Plain full-width row (no tile box, no border, no sub-text, no gap
      // above it) — sits flush under the fitted-recently toggle.
      var noIdeaRow = el('label', {
        class: 'mff-noidea',
        style: 'display:flex;align-items:center;gap:10px;width:100%;margin:0;padding:0;cursor:pointer;'
      });
      var noIdeaCheckbox = el('input', {
        type: 'checkbox',
        onchange: function (e) { self.setState({ noIdeaOfSize: e.target.checked }); }
      });
      noIdeaCheckbox.checked = !!s.noIdeaOfSize;
      noIdeaRow.appendChild(noIdeaCheckbox);
      noIdeaRow.appendChild(el('span', null, 'I really have no idea of my size'));
      step.appendChild(noIdeaRow);

    step.appendChild(this.actions(
      function () { self.setStep(1); },
      'Next →', !canContinue,
      function () {
        var s2 = self.state;
        if (s2.noIdeaOfSize) {
          Object.assign(self.state, {
            hasCurrentSize: 'no', currentBrand: '', currentBand: '', currentCup: '',
            issues: [], fitterSource: '', fittedRecently: null
          });
          self.setStep(4);
          return;
        }
        if (s2.currentBrand && s2.currentBand && s2.currentCup) self.setStep(3);
      }
    ));
    return step;
  };

  // --- step 3 (only when she knows her size): fit issues with her current bra ---
  FitFinder.prototype.renderIssues = function () {
    var self = this, s = this.state;
    var contradictions = SIZING.ISSUE_CONTRADICTIONS || {};
    var disabled = {};
    s.issues.forEach(function (id) { (contradictions[id] || []).forEach(function (c) { disabled[c] = true; }); });
    var step = el('div', { class: 'mff-step' });
    step.appendChild(this.head(this.stepEyebrow(), "What's bugging you about your current bra?",
      'Tap any that apply. Each issue points to a specific fit fix. Nothing wrong? Tell us that too.'));
    var grid = el('div', { class: 'mff-issues' });
    ISSUE_OPTIONS.forEach(function (opt) {
      var selected = s.issues.indexOf(opt.id) !== -1;
      var dis = !selected && disabled[opt.id];
      grid.appendChild(self.tile(opt.label, null, selected, dis, function () {
        if (opt.id === 'none') {
          self.setState({ issues: selected ? [] : ['none'] });
          return;
        }
        var without = s.issues.filter(function (x) { return x !== 'none'; });
        var nextList = without.indexOf(opt.id) !== -1
          ? without.filter(function (x) { return x !== opt.id; })
          : without.concat([opt.id]);
        self.setState({ issues: nextList });
      }));
    });
    step.appendChild(grid);
    step.appendChild(this.actions(
      function () { self.setStep(2); },
      'Next →', false,
      function () { self.setStep(4); }
    ));
    return step;
  };

  // --- step 4: activity ---
  FitFinder.prototype.renderActivity = function () {
    var self = this, s = this.state;
    var u = parseFloat(s.underband);
    var measuredBand = u > 0 ? SIZING.bandFromUnderband(s.units === 'cm' ? u / 2.54 : u) : null;
    var bigJump = false;
    if (s.hasCurrentSize === 'yes' && s.currentBand && measuredBand != null) {
      var stated = parseInt(s.currentBand, 10);
      if (stated % 2 !== 0) stated += 1;
      bigJump = Math.abs(stated - measuredBand) >= 4;
    }
    var step = el('div', { class: 'mff-step' });
    step.appendChild(this.head(this.stepEyebrow(), "What are you doing in it?",
      "We'll match you to the right MAAREE style for your impact level."));
    var actGrid = el('div', { class: 'mff-activity' });
    ACTIVITY_OPTS.forEach(function (opt) {
      actGrid.appendChild(self.tile(opt.label, opt.sub, s.activity === opt.id, false, function () {
        self.setState({ activity: opt.id });
      }));
    });
    step.appendChild(actGrid);

    if (bigJump) {
      var bcWrap = el('div', { class: 'mff-fitting' });
      bcWrap.appendChild(el('h3', { class: 'mff-subhead' }, 'Has your body gone through significant changes recently?'));
      bcWrap.appendChild(el('p', { class: 'mff-subhead__sub' }, 'i.e. lost weight, given birth or returning from breastfeeding.'));
      var seg = el('div', { class: 'mff-segmented mff-segmented--two' });
      ['yes','no'].forEach(function (v) {
        seg.appendChild(el('button', {
          type: 'button',
          class: 'mff-segmented__opt' + (s.bodyChange === v ? ' is-active' : ''),
          onclick: function () { self.setState({ bodyChange: v }); }
        }, v.charAt(0).toUpperCase() + v.slice(1)));
      });
      bcWrap.appendChild(seg);
      step.appendChild(bcWrap);
    }

    step.appendChild(this.actions(
      function () { self.setStep(4); },
      'See my size →', !s.activity,
      function () {
        if (!s.activity) return;
        // Compute and persist before showing result (also logs to the Sheet)
        var r = self.computeResult();
        if (r) self.persistResult(r);
        self.setStep(6);
      }
    ));
    return step;
  };

  // --- step 4.5 (optional): email capture ---
  FitFinder.prototype.renderEmail = function () {
    var self = this;
    // position:relative so the sticker (position:absolute) anchors to THIS
    // step, tucked into its own top-right corner (see ensureStickerStyles
    // for why it has to stay inside the widget's box rather than float
    // outside it).
    var step = el('div', { class: 'mff-step mff-email', style: 'position:relative;' });

    // Discount callout — the actual incentive for handing over an email,
    // not just "in case you forget". Matches the 10% code the Welcome flow
    // sends on opt-in. Black circular "sticker" in the corner, same on
    // mobile and desktop (see ensureStickerStyles).
    step.appendChild(el('div', { class: 'mff-sticker' }, [
      el('span', { class: 'mff-sticker__get' }, 'Get'),
      el('span', { class: 'mff-sticker__pct' }, '10%'),
      el('span', { class: 'mff-sticker__off' }, 'off your next sports bra')
    ]));

    step.appendChild(this.head('Almost there', "Worried you'll forget?",
      "Save your results to your inbox, and we'll pop your 10% off code in there too."));

    var nameInput = el('input', {
      type: 'text', autocomplete: 'given-name',
      class: 'mff-input', placeholder: 'First name (optional)'
    });
    step.appendChild(el('label', { class: 'mff-field' }, [
      el('span', { class: 'mff-field__label' }, 'Your name'),
      el('span', { class: 'mff-input-wrap' }, [nameInput]),
      el('span', { class: 'mff-field__hint' }, 'So we can say hello properly. Optional.')
    ]));

    var input = el('input', {
      type: 'email', inputmode: 'email', autocomplete: 'email',
      class: 'mff-input', placeholder: 'you@example.com'
    });
    step.appendChild(el('label', { class: 'mff-field' }, [
      el('span', { class: 'mff-field__label' }, 'Email address'),
      el('span', { class: 'mff-input-wrap' }, [input]),
      el('span', { class: 'mff-field__hint' }, 'By entering your details, you agree to receive emails from MAAREE, including your 10% off code. Unsubscribe anytime.')
    ]));

    var errEl = el('div', { class: 'mff-warn' });
    errEl.innerHTML = '<strong>That email doesn’t look right.</strong> Please check and try again.';
    errEl.style.display = 'none';
    step.appendChild(errEl);

    function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

    var submitBtn = el('button', {
      type: 'button', class: 'mff-btn mff-btn--primary mff-btn--lg mff-btn--block',
      onclick: function () {
        var v = (input.value || '').trim();
        if (!validEmail(v)) { errEl.style.display = ''; return; }
        errEl.style.display = 'none';
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.textContent = 'Sending…';
        var nm = (nameInput.value || '').trim();
        var rec = self.lastSubmission
          ? Object.assign({}, self.lastSubmission, { email: v, first_name: nm, name: nm, email_optin: 'yes' })
          : { email: v, first_name: nm, name: nm, email_optin: 'yes', source: 'fit-finder' };
        try { klaviyoCapture(v, rec, nm); } catch (e) {}
        // Patch this submission's Sheet row: opt-in yes + name + email.
        try {
          if (self.lastSubmission && self.lastSubmission.submission_id) {
            sendSheetUpdate({ submission_id: self.lastSubmission.submission_id, email_optin: 'yes', first_name: nm, name: nm, email: v });
          }
        } catch (e) {}
        self.emailHandled = true;
        // brief pause so the tap registers, then reveal the result
        setTimeout(function () { self.render(); }, 350);
      }
    }, 'Send my results + 10% off →');
    step.appendChild(submitBtn);

    if (!CONFIG.EMAIL_REQUIRED) {
      step.appendChild(el('button', {
        type: 'button', class: 'mff-btn mff-btn--ghost mff-btn--block',
        onclick: function () { self.emailHandled = true; self.render(); }
      }, 'No thanks, just show my size'));
    }
    return step;
  };

  // --- step 5: result ---
  FitFinder.prototype.renderResult = function () {
    var self = this;
    var r = this.computeResult();
    var step = el('div', { class: 'mff-step mff-result' });
    if (!r) {
      step.appendChild(el('p', null, 'Something went wrong with your measurements. Please go back and try again.'));
      return step;
    }

    // Dead end: nothing in our range matched and there was no usable current size.
    if (r.deadEnd) {
      step.appendChild(el('span', { class: 'mff-eyebrow' }, 'Almost there'));
      step.appendChild(el('h2', { class: 'mff-result__title' }, "Let's double-check your measurements"));
      var de = el('div', { class: 'mff-warn mff-warn--result' });
      de.innerHTML = (r.unitWarning ? r.unitWarning + ' ' : '') +
        "We couldn't match your measurements to a size in our range. Pop back and re-check them, or book a free virtual fitting and we'll size you in person.";
      step.appendChild(de);
      step.appendChild(el('button', {
        type: 'button', class: 'mff-btn mff-btn--primary mff-btn--lg mff-btn--block',
        onclick: function () { self.setStep(4); }
      }, 'Re-check my measurements'));
      step.appendChild(el('a', {
        href: 'https://www.maaree.com/pages/online-zoom-fittings',
        class: 'mff-btn mff-btn--ghost mff-btn--block', target: '_blank', rel: 'noopener'
      }, 'Book a free virtual fitting'));
      return step;
    }

    var best = STYLE_META[r.bestStyle];
    var bestRec = r.recs[r.bestStyle];
    var bestProd = self.products[r.bestStyle];
    var headlineSize = (r.region && r.region !== 'UK' && r.localised) ? r.localised.label : r.ukSize;

    step.appendChild(el('span', { class: 'mff-eyebrow' }, 'Your MAAREE fit'));
    var title = el('h2', { class: 'mff-result__title' });
    title.innerHTML = "You're a <span class=\"mff-result__size\"></span>";
    title.querySelector('.mff-result__size').textContent = headlineSize;
    step.appendChild(title);
    step.appendChild(el('p', { class: 'mff-result__lede' }, 'Below is your size in every MAAREE style, plus our top pick for what you do.'));

    // Re-measure / units banner (only when something looks off)
    if (r.unitWarning || (r.flag && r.flagReasons && r.flagReasons.length)) {
      var banner = el('div', { class: 'mff-warn mff-warn--result' });
      if (r.unitWarning) {
        banner.innerHTML = '<strong>Quick note.</strong> ' + r.unitWarning;
      } else {
        banner.innerHTML = "<strong>Worth double-checking.</strong> Your measurements look a little unusual (" +
          r.flagReasons.join(', ') + "), so this size might not be spot on. It is worth re-measuring, or booking a free virtual fitting below to be sure.";
      }
      step.appendChild(banner);
    }

    // Hero
    var hero = el('div', { class: 'mff-hero' });
    var heroLeft = el('div', { class: 'mff-hero__label' }, [
      el('span', { class: 'mff-eyebrow' }, 'Best for you'),
      el('h3', { class: 'mff-hero__name' }, (bestProd && bestProd.title) ? bestProd.title : (best.name + ' Bra')),
      el('p', { class: 'mff-hero__why' }, r.bestReason)
    ]);
    if (bestRec && !bestRec.unavailable) {
      heroLeft.appendChild(el('div', { class: 'mff-hero__size' }, [
        el('span', { class: 'mff-hero__size-label' }, 'Your size'),
        el('span', { class: 'mff-hero__size-val' }, localiseDisplay(bestRec, r.region))
      ]));
    }
    if (bestRec && bestRec.note) heroLeft.appendChild(el('p', { class: 'mff-hero__note' }, bestRec.note));
    var ctas = el('div', { class: 'mff-hero__ctas' });
    var bestHref = (bestProd && bestProd.url) || this.urls[r.bestStyle] || best.url;
    ctas.appendChild(el('a', {
      href: bestHref, class: 'mff-btn mff-btn--primary mff-btn--lg', target: '_blank', rel: 'noopener'
    }, 'View product'));
    heroLeft.appendChild(ctas);
    hero.appendChild(heroLeft);
    var heroMedia = el('div', { class: 'mff-hero__media' });
    if (bestProd && bestProd.image) {
      heroMedia.appendChild(el('img', {
        class: 'mff-hero__image',
        src: bestProd.image,
        alt: (bestProd.title || (best.name + ' Bra')),
        loading: 'lazy'
      }));
    } else {
      heroMedia.appendChild(el('div', { class: 'mff-hero__placeholder' }, [
        el('span', null, best.name),
        el('small', null, 'Product imagery')
      ]));
    }
    heroMedia.appendChild(el('span', { class: 'mff-badge' }, best.impact + ' impact'));
    hero.appendChild(heroMedia);
    step.appendChild(hero);

    // All styles
    var all = el('div', { class: 'mff-allstyles' });
    all.appendChild(el('h3', { class: 'mff-subhead' }, 'Your size in every style'));
    var grid = el('div', { class: 'mff-allstyles__grid' });
    ['solidarity','battle','empower','uplift','seamless'].forEach(function (key) {
      var meta = STYLE_META[key];
      var rec = r.recs[key];
      var prod = self.products[key];
      var isBest = key === r.bestStyle;
      var hasThumb = !!(prod && prod.image);
      var card = el('a', {
        href: (prod && prod.url) || self.urls[key] || meta.url, target: '_blank', rel: 'noopener',
        class: 'mff-card' + (isBest ? ' is-best' : '') + (rec.unavailable ? ' is-unavailable' : '') + (hasThumb ? ' mff-card--has-thumb' : '')
      });
      if (isBest && !rec.unavailable) card.appendChild(el('span', { class: 'mff-card__flag' }, 'Top pick'));
      if (hasThumb) {
        card.appendChild(el('img', {
          class: 'mff-card__thumb',
          src: prod.image,
          alt: (prod.title || meta.name),
          loading: 'lazy'
        }));
      }
      var head = el('span', { class: 'mff-card__head' }, [
        el('span', { class: 'mff-card__name' }, (prod && prod.title) ? prod.title : meta.name),
        el('span', { class: 'mff-card__impact' }, meta.impact + ' impact')
      ]);
      card.appendChild(head);
      if (rec.unavailable) {
        card.appendChild(el('span', { class: 'mff-card__unavailable' }, 'Not in your size'));
      } else {
        card.appendChild(el('span', { class: 'mff-card__size' }, localiseDisplay(rec, r.region)));
        card.appendChild(el('span', { class: 'mff-card__tagline' }, meta.tagline));
      }
      if (rec.note) card.appendChild(el('span', { class: 'mff-card__warn' }, rec.note));
      if (rec.warn) card.appendChild(el('span', { class: 'mff-card__warn' }, rec.warn));
      grid.appendChild(card);
    });
    all.appendChild(grid);
    step.appendChild(all);

    // Notes
    if (r.notes && r.notes.length) {
      var notes = el('div', { class: 'mff-reasoning' });
      notes.appendChild(el('h3', { class: 'mff-subhead' }, 'Why we picked ' + headlineSize + ' for you'));
      var ul = el('ul');
      r.notes.forEach(function (n) { ul.appendChild(el('li', null, n)); });
      notes.appendChild(ul);
      step.appendChild(notes);
    }

    // Sister sizes (collapsed)
    var sisterOpen = false;
    var sister = el('div', { class: 'mff-sister' });
    var toggle = el('button', { type: 'button', class: 'mff-sister__toggle' });
    toggle.innerHTML = '<span>Want a tighter or looser band? See alternative sizes</span>' +
      '<svg viewBox="0 0 16 16" width="14" height="14" class="mff-sister__chev"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var body = el('div', { class: 'mff-sister__body' });
    body.style.display = 'none';
    toggle.addEventListener('click', function () {
      sisterOpen = !sisterOpen;
      body.style.display = sisterOpen ? '' : 'none';
      sister.classList.toggle('is-open', sisterOpen);
    });
    var row = el('div', { class: 'mff-sister__row' });
    if (r.sister.down) {
      var downLoc = SIZING.localiseSize(r.sister.down.band, r.sister.down.cup, r.region);
      row.appendChild(el('div', { class: 'mff-sister__card' }, [
        el('span', { class: 'mff-sister__label' }, 'Tighter band'),
        el('span', { class: 'mff-sister__size' }, downLoc.label),
        el('span', { class: 'mff-sister__note' }, 'For a firmer fit')
      ]));
    }
    row.appendChild(el('div', { class: 'mff-sister__card mff-sister__card--main' }, [
      el('span', { class: 'mff-sister__label' }, 'Your size'),
      el('span', { class: 'mff-sister__size' }, headlineSize),
      el('span', { class: 'mff-sister__note' }, 'Recommended')
    ]));
    if (r.sister.up) {
      var upLoc = SIZING.localiseSize(r.sister.up.band, r.sister.up.cup, r.region);
      row.appendChild(el('div', { class: 'mff-sister__card' }, [
        el('span', { class: 'mff-sister__label' }, 'Looser band'),
        el('span', { class: 'mff-sister__size' }, upLoc.label),
        el('span', { class: 'mff-sister__note' }, 'For a gentler fit')
      ]));
    }
    body.appendChild(row);
    sister.appendChild(toggle);
    sister.appendChild(body);
    step.appendChild(sister);

    // Boost breast form size. Only when she ticked the box on the intro,
    // and only while the campaign is running.
    if (CONFIG.BOOST_ENABLED && self.state.boost) {
      var bz = r.boost || { size: null, inChart: false };
      var boostCard = el('div', { class: 'mff-boost' });
      boostCard.appendChild(el('span', { class: 'mff-eyebrow' }, CONFIG.BOOST_EYEBROW));
      boostCard.appendChild(el('h3', { class: 'mff-boost__title' }, CONFIG.BOOST_TITLE));
      if (bz.inChart) {
        var opts = bz.options;
        var sizebox = el('div', { class: 'mff-boost__sizebox' + (opts.length > 1 ? ' mff-boost__sizebox--two' : '') });
        opts.forEach(function (o) {
          sizebox.appendChild(el('div', { class: 'mff-boost__opt' }, [
            el('span', { class: 'mff-boost__size' }, o.size),
            el('span', { class: 'mff-boost__name' }, o.name),
            el('span', { class: 'mff-boost__shape' }, o.shape)
          ]));
        });
        boostCard.appendChild(sizebox);
        if (opts.length > 1) {
          var shapeLines = opts.map(function (o) { return o.shape + ' is ' + o.shapeNote + '.'; }).join(' ');
          boostCard.appendChild(el('p', { class: 'mff-boost__body' },
            'Boost list two forms for a ' + headlineSize + ', and either works. ' + shapeLines +
            ' A fitter can tell you which suits you in a minute.'));
        } else {
          var o1 = opts[0];
          boostCard.appendChild(el('p', { class: 'mff-boost__body' },
            'Boost size their forms from your bra size, and a ' + headlineSize + ' puts you in a ' +
            o1.name.toLowerCase() + ' in their ' + o1.shape + ' shape, ' + o1.shapeNote + '.'));
        }
      } else {
        boostCard.appendChild(el('p', { class: 'mff-boost__body' },
          'Boost’s size guide does not cover a ' + headlineSize + ', so this one is better done with a person than a table.'));
      }
      boostCard.appendChild(el('p', { class: 'mff-boost__note' }, CONFIG.BOOST_NOTE));
      if (CONFIG.BOOST_CTA_URL) {
        boostCard.appendChild(el('a', {
          href: CONFIG.BOOST_CTA_URL, target: '_blank', rel: 'noopener',
          class: 'mff-btn mff-btn--primary mff-btn--lg mff-btn--block'
        }, CONFIG.BOOST_CTA_LABEL));
      }
      step.appendChild(boostCard);
    }

    step.appendChild(el('button', {
      type: 'button', class: 'mff-btn mff-btn--ghost mff-btn--block',
      onclick: function () { self.restart(); }
    }, 'Start over'));

    // Virtual fitting upsell — positive framing, not "in case you don't trust us"
    var virtual = el('div', { class: 'mff-virtual' });
    virtual.appendChild(el('span', { class: 'mff-eyebrow' }, 'Want a second opinion?'));
    virtual.appendChild(el('h3', { class: 'mff-virtual__title' }, 'Get a free 1-to-1 virtual fitting'));
    virtual.appendChild(el('p', { class: 'mff-virtual__sub' },
      'Hop on Zoom with one of our expert fitters for personalised guidance. It’s free, friendly, and you can ask anything — from style choice to fit nuances.'));
    virtual.appendChild(el('a', {
      href: 'https://www.maaree.com/pages/online-zoom-fittings',
      target: '_blank', rel: 'noopener',
      class: 'mff-btn mff-btn--secondary mff-btn--lg mff-btn--block'
    }, 'Book a free virtual fitting →'));
    step.appendChild(virtual);

    return step;
  };

  // ============================================================
  // Public API
  // ============================================================
  var MaareeFitFinder = {
    mount: function (target, opts) {
      var root = typeof target === 'string' ? document.querySelector(target) : target;
      if (!root) return null;
      return new FitFinder(root, opts);
    },
    getStored: loadStored,
    clear: clearStored,
    STORAGE_KEY: STORAGE_KEY,
    STYLE_META: STYLE_META
  };

  // ============================================================
  // Drawer wrapper (desktop side-drawer / mobile full-screen)
  // ============================================================
  MaareeFitFinder.openDrawer = function (opts) {
    opts = opts || {};
    // Tear down any existing drawer
    var existing = document.querySelector('.mff-drawer-root');
    if (existing) existing.parentNode.removeChild(existing);

    var root = el('div', { class: 'mff-drawer-root' });
    var backdrop = el('div', { class: 'mff-drawer__backdrop' });
    var panel = el('div', { class: 'mff-drawer__panel', role: 'dialog', 'aria-label': 'The MAAREE Bra Fit Finder' });
    var head = el('div', { class: 'mff-drawer__head' }, [
      el('span', { class: 'mff-drawer__title' }, 'The MAAREE Bra Fit Finder'),
      el('button', {
        type: 'button', class: 'mff-drawer__close', 'aria-label': 'Close',
        onclick: close
      }, '✕')
    ]);
    var mountEl = el('div', { class: 'mff-drawer__body' });
    panel.appendChild(head);
    panel.appendChild(mountEl);
    root.appendChild(backdrop);
    root.appendChild(panel);
    document.body.appendChild(root);
    document.body.classList.add('mff-noscroll');

    function close() {
      root.classList.add('is-closing');
      setTimeout(function () {
        if (root.parentNode) root.parentNode.removeChild(root);
        document.body.classList.remove('mff-noscroll');
      }, 240);
    }
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onEsc); }
    });

    // Trigger animation
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    var inst = MaareeFitFinder.mount(mountEl, Object.assign({}, opts, {
      onComplete: function (payload) {
        if (opts.onComplete) opts.onComplete(payload);
      }
    }));
    return { instance: inst, close: close };
  };

  global.MaareeFitFinder = MaareeFitFinder;
})(window);